module.exports = __webpack_public_path__ + "media/images/face-3fdc38400c1fefa48555e2748c3ce5fd.jpg";